export interface IWholesaleMarket {
  code: string;
  name: string;
}

export const wholesaleMarketConstants: IWholesaleMarket[] = [
  {
    code: '110001',
    name: '서울가락',
  },
  {
    code: '110008',
    name: '서울강서',
  },
  {
    code: '210001',
    name: '부산엄궁',
  },
  {
    code: '210005',
    name: '부산국제수산',
  },
  {
    code: '210009',
    name: '부산반여',
  },
  {
    code: '220001',
    name: '대구북부',
  },
  {
    code: '230001',
    name: '인천남촌',
  },
  {
    code: '230003',
    name: '인천삼산',
  },
  {
    code: '240001',
    name: '광주각화',
  },
  {
    code: '240004',
    name: '광주서부',
  },
  {
    code: '250001',
    name: '대전오정',
  },
  {
    code: '250003',
    name: '대전노은',
  },
  {
    code: '310101',
    name: '수원',
  },
  {
    code: '310401',
    name: '안양',
  },
  {
    code: '310901',
    name: '안산',
  },
  {
    code: '311201',
    name: '구리',
  },
  {
    code: '320101',
    name: '춘천',
  },
  {
    code: '320201',
    name: '원주',
  },
  {
    code: '320301',
    name: '강릉',
  },
  {
    code: '330101',
    name: '청주',
  },
  {
    code: '330201',
    name: '충주',
  },
  {
    code: '340101',
    name: '천안',
  },
  {
    code: '350101',
    name: '전주',
  },
  {
    code: '350301',
    name: '익산',
  },
  {
    code: '350402',
    name: '정읍',
  },
  {
    code: '360301',
    name: '순천',
  },
  {
    code: '370101',
    name: '포항',
  },
  {
    code: '370401',
    name: '안동',
  },
  {
    code: '371501',
    name: '구미',
  },
  {
    code: '380101',
    name: '창원팔용',
  },
  {
    code: '380201',
    name: '울산',
  },
  {
    code: '380303',
    name: '창원내서',
  },
  {
    code: '380401',
    name: '진주',
  },
];
